<template>
    <b-button size="sm" :variant="variant" class="mr-2 text-center" :disabled="disabled">
        <template v-if="!disabled || hasLoad">
            <slot></slot>
        </template>
        <template v-if="disabled && !hasLoad"><i style="font-size: 15px;" class="fas fa-spinner fa-pulse"></i></template>
    </b-button>
</template>
<script>
export default {
    name: 'button-validation',
    props: ['variant','disabled','hasLoad']
}
</script>
